/**
 * Journal technique de la console (ré-audit DT-6) : un seul point d'entrée
 * pour les erreurs et avertissements, au lieu d'appels `console.*` épars.
 *
 * Chaque entrée porte un contexte (« [Écran][action] ») puis les détails.
 * Aujourd'hui le journal écrit dans la console du navigateur ; un envoi vers
 * un service de suivi se branchera ici sans toucher aux écrans.
 */

type Details = readonly unknown[];

export const logger = {
  /** Échec d'une action ou d'une lecture (avec l'erreur reçue). */
  error: (context: string, ...details: Details): void => {
    console.error(context, ...details);
  },
  /** Situation anormale non bloquante. */
  warn: (context: string, ...details: Details): void => {
    console.warn(context, ...details);
  },
};
